import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import ActionButton from '@/components/action_button/Index.vue';
import RaffleDrawDetails from '@/plugins/graphql/queries/v2/survey/raffle-draw.gql';
import BaseDetails from '@/components/v2/BaseDetails';
import BaseDetailsCard from '@/components/v2/BaseDetailsCard';
let CampaignRaffleDetails = class CampaignRaffleDetails extends mixins(RouterParamsAppMixin) {
};
__decorate([
    Prop({ type: String, required: true })
], CampaignRaffleDetails.prototype, "uuid", void 0);
CampaignRaffleDetails = __decorate([
    Component({
        components: {
            PageTitle,
            ActionButton,
            BaseDetails,
            BaseDetailsCard,
        },
        apollo: {
            raffleDraw: {
                query: RaffleDrawDetails,
                variables() {
                    const raffleDrawUuid = this.uuid;
                    return {
                        raffleDrawUuid,
                    };
                },
                update(data) {
                    return data.raffleDraw;
                },
            },
        },
    })
], CampaignRaffleDetails);
export default CampaignRaffleDetails;
